export default __webpack_public_path__ + "static/media/pump-panel.aecf1ca7.webp";